import { motion } from "framer-motion";
import PickupAvailableImg from "../assets/pickup_img.png";
import { brands, homeServices, services } from "./constants";

const Services = () => {
  return (
    <div className="container py-20">
      {/* Services Header */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="text-center mb-16"
      >
        <h1 className="text-4xl font-bold mb-6">Our Services</h1>
        <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
          We offer comprehensive camera services to keep your equipment in
          perfect condition and help you capture the perfect shot.
        </p>
      </motion.div>

      {/* Services Grid */}
      {/* <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-20">
        {services.map((service, index) => (
          <motion.div
            key={service.title}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
            className="flex flex-col items-center text-center p-6 bg-muted/50 rounded-lg hover:bg-muted/70 transition-colors"
          >
            <div className="p-4 rounded-full bg-primary/10 text-primary mb-4">
              {service.icon}
            </div>
            <h3 className="text-xl font-bold mb-2">{service.title}</h3>
            <p className="text-muted-foreground">{service.description}</p>
          </motion.div>
        ))}
      </div> */}
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-20">
        {homeServices.map((service, index) => (
          <motion.div
            key={service.title}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
            className="flex flex-col items-center text-center p-6 bg-muted/50 rounded-lg hover:bg-muted/70 transition-colors"
          >
            <div className="p-4 rounded-full bg-primary/10 text-primary mb-4">
              {service.icon}
            </div>
            <h3 className="text-xl font-bold mb-2">{service.title}</h3>
            <p className="text-muted-foreground">{service.description}</p>
          </motion.div>
        ))}
      </div>

      {/* Pickup & Delivery and Supported Brands Section */}
      <div className="flex flex-col md:flex-row gap-8 items-stretch justify-center my-12">
        {/* Pickup & Delivery Service (Left) */}
        <div className="flex flex-col items-center md:items-start bg-muted/50 rounded-lg hover:bg-muted/70 transition-colors p-6 w-full md:w-1/2">
          <img
            src={PickupAvailableImg}
            alt="Camera Service Pickup Available"
            className="w-40 h-[fit-content]"
          />
          <div className="font-semibold text-lg">
            <span className="font-bold">Pickup & Delivery Service</span>
            <br />
            <p
              className="text-muted-foreground mt-2"
              style={{ fontSize: "15px" }}
            >
              We offer convenient{" "}
              <span className="font-bold text-lg">Pick up and Delivery</span>{" "}
              for all camera services. Whether your camera needs repair,
              cleaning, or calibration, our team will collect your equipment
              from your doorstep and deliver it back to you once the service is
              complete.
              <br />
              {/* <span className="font-bold text-lg">Pre-owned cameras</span>{" "}
              purchased from us will also be delivered safely to your address,
              ensuring a hassle-free experience from start to finish. */}
            </p>
          </div>
        </div>
        {/* Supported Brands (Right) */}
        <div className="flex flex-col items-center justify-center bg-muted/50 rounded-lg hover:bg-muted/70 rounded-lg shadow-md p-6 w-full md:w-1/2">
          <h2 className="text-2xl font-bold mb-4 text-primary">
            Supported Brands
          </h2>
          <div className="flex flex-col md:flex-row flex-wrap justify-center gap-5 w-full items-center">
            {brands.map((brand, index) => (
              <motion.div
                key={brand.name}
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.4, delay: index * 0.08 }}
                className="px-5 py-2 bg-background rounded-full shadow border border-primary/20 text-primary font-semibold text-base tracking-wide hover:bg-muted/70 transition-colors duration-200 flex items-center gap-2"
                style={{ textAlign: "center" }}
              >
                <img
                  src={brand.img}
                  alt={brand.name + " logo"}
                  style={{
                    width: 28,
                    height: 28,
                    objectFit: "contain",
                    marginRight: 8,
                    background: "white",
                    borderRadius: "50%",
                  }}
                />
                {brand.name}
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Services;
